module.exports = __webpack_public_path__ + "img/bilibili1.0e0f5334.png";